// 日期提醒管理
import {contractApi} from "@/axios";
export function getRemindersList(uuid){
    return contractApi({
        url:'/calendar-reminders/list/' + uuid,
        method:'get'
    })
}
export function deleteReminders(params){
    return contractApi({
        url:'/calendar-reminders',
        method:'delete',
        params:params
    })
}
export function addReminders(data){
    return contractApi({
        url:'/calendar-reminders',
        method:'post',
        data:data
    })
}
export function editReminders(data){
    return contractApi({
        url:'/calendar-reminders',
        method:'put',
        data:data
    })
}
export function getRemindersPage(params,data){
    return contractApi({
        url:'/calendar-reminders/page',
        method:'post',
        params:params,
        data:data
    })
}